import * as React from "react";
import { useState } from "react";
import { History } from "history";
import { TicketEvent } from "../../models/ticketEvent";
import { EventDetails } from "../eventDetails/eventDetails";
import { Server } from "../../services/server";
import { container } from "../../services/container";
import { PageComponentProps } from "../pageComponent";
import { Facebook } from "../../services/facebook";
import topLogo from "../../assets/images/top_logo.svg";
import { useObservable } from "../../hooks/use-observable";
import { HttpError } from "../../errors/httpError";
import { EventPasswordModal } from "../event-password-modal";
import { switchMap } from "rxjs/operators";

interface EventDetailsPageProps extends PageComponentProps<{ id: string, ticketTypeId: string | null }> {
  history: History;
}

export function EventDetailsPage({ match, history }: EventDetailsPageProps) {
  const [retry, setRetry] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [event] = useObservable(
    ($inputs) =>
      $inputs.pipe(
        switchMap(() => {
          const server = container.get(Server);
          return server.get(TicketEvent, `ticket-events/upcoming/${match.params.id}`).catch(async (error) => {
            if (error instanceof HttpError && error.response.status === 403) {
              const errorBody = await error.response.json();

              if (errorBody.needsPassword) {
                setShowPasswordModal(true);
              }
            }
          });
        })
      ),
    null as TicketEvent | null,
    [match.params.id, retry]
  );

  return (
    <div className="nav-page event-details-page">
      <img className="top-logo" src={topLogo} alt="" />
      <div className="top-logo-sep" />
      {event && !showPasswordModal && <EventDetails event={event} preselectedTicketTypeId={match.params.ticketTypeId} history={history} />}

      <EventPasswordModal
        eventId={match.params.id}
        show={showPasswordModal}
        onDismissModal={() => {
          setShowPasswordModal(false);
          setRetry((value) => !value);
        }}
      />
    </div>
  );
}
